import { Injectable } from "@angular/core";

@Injectable()
export class LocationService {
  position: string;

  constructor() {
    let pullLocation = () => {
      window.navigator.geolocation.getCurrentPosition(
        (pos) => {
          this.position =
            "<geo:" + pos.coords.latitude + "," + pos.coords.longitude + ">";
        },
        (err) => {
          if (err.code === 1) {
            this.position = "USER_DENIED";
          } else {
            this.position = "UNKNOWN";
          }
        }
      );
    };

    if (window.navigator.geolocation) {
      pullLocation();
      setInterval(pullLocation, 60000);
    }
  }

  getPosition(): string {
    return this.position;
  }
}



// WEBPACK FOOTER //
// ./src/app/location/location.service.ts